import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatiqToggleButtonComponent } from './components';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { ReactiveFormsModule } from '@angular/forms';

const components = [DatiqToggleButtonComponent];
@NgModule({
    declarations: [...components],
    imports: [CommonModule, MatButtonToggleModule, ReactiveFormsModule],
    exports: [...components],
})
export class DatiqToggleButtonModule {}
